import { Nps } from './types'
import client from '../../client'
import { ResponseSuccess } from '../../types'

export const getNps = () => client.get<ResponseSuccess<Nps>>('v1/users/nps')

export const updateNps = async () => await client.post('v1/users/nps')
